import React from 'react';
import { ReactComponent as Send } from '../../assets/images/icons/send.svg';

export default function SendIcon(props) {
  return (
    <Send className={`icon ${props.className}`} />
  );
}
